import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";

import { BasicForm } from "@components/shared";
import { affiliateVarieties, affiliateClassifications } from "./helpers";

export default function AffiliateForm({
  id = null,
  name = "",
  onSuccess = () => {},
  variety = "",
  classification = "",
}) {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  function onSubmit(formData) {
    setLoading(true);

    if (id) return onUpdate(formData);

    return onCreate(formData);
  }

  function onCreate(formData) {
    const req = {
      ...formData,
    };

    axios
      .post(`/affiliates/`, req)
      .then(({ data }) => {
        toast.success(t("common:created"));
        setLoading(false);
        // navigate(`/affiliates/${data.response[0].id}`);
        onSuccess();
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  function onUpdate(formData) {
    const req = {
      ...formData,
      affiliate_id: id,
    };

    axios
      .put(`/affiliates/${id}/`, req)
      .then(() => setLoading(false))
      .then(() => toast.success(t("common:updated") + "!"))
      .then(() => onSuccess())
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  const fields = [
    {
      name: "name",
      label: t("common:name"),
      initialValue: name,
      required: true,
      schema: () =>
        Yup.string()
          .max(100, t("validation:too_long"))
          .required(t("validation:required")),
    },
    {
      name: "classification",
      label: t("common:classification"),
      initialValue: classification,
      select: true,
      options: affiliateClassifications,
      required: true,
      schema: () => Yup.string().nullable().required(t("validation:required")),
    },
    {
      name: "variety",
      label: t("common:variety"),
      initialValue: variety,
      select: true,
      options: affiliateVarieties,
      required: true,
      schema: () => Yup.string().nullable().required(t("validation:required")),
    },
  ];

  return (
    <BasicForm
      buttonProps={{
        fullWidth: !id ? true : false,
      }}
      loading={loading}
      onSubmit={onSubmit}
      fields={fields}
    />
  );
}
